/**
 * Created by fworld on 2019/6/29.
 */
const device = {
    name: 'orgnization',
    path: '/delivery/organization',
    meta: {title: '成员管理'},
    component: () => import('@/pages/redirect'),
    redirect: {name: 'delivery.organization.chart'},
    children: [
        {
            name: 'delivery.organization.chart',
            path: 'chart',
            meta: {title: '组织架构'},
            component: () => import('@/pages/Delivery/Organization/Chart'),
        },
        {
            name: 'delivery.organization.users',
            path: 'users',
            meta: {title: '成员列表'},
            component: () => import('@/pages/Delivery/Organization/Users'),
        },
    ]
}

export default device
